/**
 * Skjult honeypot-felt ("website") — mennesker ser det aldrig og lader det være
 * tomt; bots der udfylder alle felter bliver afvist af DriveGo.
 */
const HoneypotField = ({ value, onChange }) => (
  <div
    aria-hidden="true"
    style={{ position: "absolute", left: "-10000px", top: "auto", width: 1, height: 1, overflow: "hidden" }}
  >
    <label>
      Website
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  </div>
);

export default HoneypotField;
